<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>鸿图归来运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>开区红包</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
      <el-row>
        <el-button type="primary" size="small" @click="$router.push('/openZoneAdd')">添加</el-button>
      </el-row>
      <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%">
        <el-table-column
            prop="red_id"
            label="红包id"
            width="80">
        </el-table-column>
        <el-table-column
            prop="add_user_id"
            label="添加人"
            width="80">
        </el-table-column>
        <el-table-column
            prop="money"
            label="红包金额"
            width="80">
        </el-table-column>
        <el-table-column
            prop="num"
            label="红包数"
            width="80">
        </el-table-column>
        <el-table-column
            width="280"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showReserveDialog(scope.row.red_id)">添加预定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="15"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
    <el-dialog
        title="添加预定"
        :visible.sync="reserveDialogVisible"
        width="30%">
      <el-form ref="form" :model="dialogForm" :rules="dialogRules" label-width="100px">
        <el-form-item label="用户ID" prop="userId">
          <el-input size="small" v-model="dialogForm.userId" placeholder="请输入用户id"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input size="small" v-model="dialogForm.userName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="红包金额" prop="money">
          <el-input size="small" v-model="dialogForm.money" placeholder="请输入红包金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="reserveDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addReserve">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryOpenZoneRed,addFixed } from '@/api/request';
export default {
  name: "openZone",
  data(){
    return {
      form:{
        redId: '',
        addUserId: '',
        serverName: ''
      },
      dialogForm:{
        userId: '',
        userName: '',
        money: '',
      },
      reserveRedId: '',
      dialogRules: {
        userId: [{ required: true, message: '请输入用户id', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        money: [{ required: true, message: '请输入红包金额', trigger: 'blur' }],
      },
      tableData: [],
      height: window.innerHeight - 220,
      total: 0,
      currentIndex: 1,
      reserveDialogVisible: false,
    }
  },
  mounted() {
    this.loadData(1);
  },
  methods:{
    loadData(index){
      let params = {
        pageNo: index,
        pageSize: 15,
        params: this.form
      }
      queryOpenZoneRed(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    addReserve(){
      let params = {
        userId: this.dialogForm.userId,
        userName: this.dialogForm.userName,
        money: this.dialogForm.money,
        redId: this.reserveRedId
      }
      addFixed(params).then(res => {
        if (res.data.success) {
          this.$message.success('添加内定成功');
        } else {
          this.$message.error(res.data.error.message);
        }
      }).finally(() => {
        this.reserveDialogVisible = false;
        this.dialogForm = {
          userId: '',
          userName: '',
          money: '',
        }
      })
    },
    showReserveDialog(redId){
      this.reserveDialogVisible = true;
      this.reserveRedId = redId;
    }
  }
}
</script>

<style scoped>

</style>